import { Component, OnInit, inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from "@angular/material/dialog";
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from "@angular/material/table";
import { IOrder } from "../core/models/IOrders";
import { DataAccessService } from "../core/services/data-access.service";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatSort, MatSortHeader } from "@angular/material/sort";
import { MatButton } from "@angular/material/button";
import { DatePipe } from "@angular/common";

@Component({
    selector: "history_dialog",
    templateUrl: "history_dialog.html",
    styleUrls: ["./orders.component.scss"],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatDialogActions, MatButton, DatePipe]
})
export class OrderHistoryDialog implements OnInit {
  dialogRef = inject<MatDialogRef<OrderHistoryDialog>>(MatDialogRef);
  data = inject<object>(MAT_DIALOG_DATA);
  private dataAccess = inject(DataAccessService);

  displayedColumns: string[] = [
    "change_date",
    "changed_by",
    "line_no",
    "status",
    "line_type",
    "original_qty",
    "original_date",
    "updated_original_date",
    "confirmed_qty",
    "confirmed_date",
    "dispatched_qty",
    "dispatched_date",
    "unloaded_qty",
    "unloaded_date",
    "customers_comments",
    "suppliers_comments",
  ];
  dataSource: MatTableDataSource<IOrder>;

  id: number;
  orderNo: string;

  constructor() {
    const data = this.data;

    this.id = (data as any).lineId;
  }

  ngOnInit() {
    this.dataAccess
      .getJSONPost("get_line_history", [], [{ k: "p_line_id", v: this.id }])
      .then((data) => {
        this.dataSource = data;
        this.orderNo = data[0].order_no;
      });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
